module.exports = __webpack_public_path__ + "img/kucun-hei.0c838090.svg";